import React from 'react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <main className="container mx-auto px-4 py-8 flex-grow">
        <div className="max-w-3xl mx-auto space-y-6">
          <h1 className="text-3xl font-bold">Terms of Service</h1>
          <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
          
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">1. Acceptance of Terms</h2>
            <p>
              By accessing and using DocVerifAI ("Service"), you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">2. Description of Service</h2>
            <p>
              DocVerifAI provides document verification and analysis services. We process documents to extract and verify information using artificial intelligence and machine learning technologies.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">3. User Responsibilities</h2>
            <p>You agree to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide accurate information when using the Service</li>
              <li>Maintain the security of your account credentials</li>
              <li>Use the Service in compliance with applicable laws</li>
              <li>Not misuse or attempt to circumvent the Service</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">4. Intellectual Property</h2>
            <p>
              The Service, including its original content, features, and functionality, is owned by DocVerifAI and is protected by international copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">5. Privacy and Data Protection</h2>
            <p>
              Your use of the Service is also governed by our Privacy Policy. By using the Service, you consent to the collection and use of information as detailed in our Privacy Policy.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">6. Limitation of Liability</h2>
            <p>
              DocVerifAI shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the Service.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">7. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the Service.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">8. Contact Information</h2>
            <p>
              For questions about these Terms of Service, please contact us at:{' '}
              <a href="mailto:hello@docverifai.com" className="text-primary hover:underline">
                hello@docverifai.com
              </a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
} 
